import BasePointManager from "../../../../../../src/managers/BasePointManager";
import Point from "../../../../../../src/entities/Point";
import { Coord, RedPointRadianInfo } from "../../../../../../src/types/Interface";
import { CIRCLE_RADIUS, INITIAL_RADIANS } from "../../types/Config";
import { eventBus, EnumEventBus } from "../EventBus";
import { findIntersection, findTangentCoords, generateRandomlyRadians, getPointInfoArr } from "./helpers/pointHelpers";


export default class PointManager extends BasePointManager {
  intersecPoint = new Point({ x: -100, y: -100 });
  private pointCheckList: Boolean[] = [];

  constructor(cCoord: Coord) {
    super(cCoord, CIRCLE_RADIUS, INITIAL_RADIANS);
    this.setCoord();
    this.draw();
    
    const intersecCoord = this.getIntersecCoord();
    this.intersecPoint.draw(intersecCoord);

    eventBus.on(EnumEventBus.setPointChecklist, l => this.pointCheckList = l);
    eventBus.on(EnumEventBus.moveCircumPoints, (v: number) => this.moveCircumPoints(v));
    eventBus.on(EnumEventBus.genRanIntersec, () => this.generateNewIntersection());
  }
  setIntersecPointVisible=(v:boolean)=>this.intersecPoint.visible=v;
  generateNewIntersection = () => generateRandomlyRadians(this);
  getIntersecCoord = () => findIntersection(this.cCoord, this.RedPointsArr[0], this.RedPointsArr[1]);
  getTangentCoords = (clockwise: boolean) => findTangentCoords(this.cCoord, this.RedPointsArr[0], this.RedPointsArr[1], clockwise);

  setRadian(_pointInfoArr: RedPointRadianInfo[], isSlider?: boolean): void {
    const pointInfoArr = getPointInfoArr(_pointInfoArr, this.RedPointsArr, this.pointRadians)
    this._setRadian(pointInfoArr, isSlider);

    if(this.intersecPoint.visible){
      const intersecCoord = this.getIntersecCoord();
      this.intersecPoint.draw(intersecCoord);
    }
  }

  moveCircumPoints(v: number) {
    const points = this.getRedPoints();
    const radians = this.getRefRadians();
    const generateOffsetRadian = (v: number) => (Math.PI / 300) * v;
    const pointInfoArr = this.pointCheckList
      .map((e, eI) => this.pointRefRadians[eI] + (e ? generateOffsetRadian(v) : 0))
      .map((r, rI) => ({ pTag: points[rI].tag, radian: r }))
      .filter((pointInfo, pII) => pointInfo.radian != radians[pII]);

    this.setRadian(pointInfoArr, true);
  }
}


